<ng-container *ngIf="smartHomeComponents?.length">
  <app-feature-list-container
    title="{{ '+INSTALLATIONS.INSTALLATION.SMART_HOME_COMPONENT.TITLE' | translate }}"
  >
    <mat-form-field mat-select-height-large floatlLabel="never">
      <mat-label>{{
        '+INSTALLATIONS.INSTALLATION.SMART_HOME_COMPONENT.COMPONENT' | translate
      }}</mat-label>
      <mat-select [formControl]="smartHomeComponentsControl" multiple fieldTextContentTooltip>
        <mat-select-trigger>{{
          '+INSTALLATIONS.INSTALLATION.SMART_HOME_COMPONENT.PLEASE_CHOOSE' | translate
        }}</mat-select-trigger>
        <mat-option
          *ngFor="let smartHomeComponent of smartHomeComponents"
          [disabled]="smartHomeComponent.deleted"
          (onSelectionChange)="select($event, smartHomeComponent)"
          [value]="smartHomeComponent"
          fieldTextContentTooltip
          >{{ smartHomeComponent.name }}</mat-option
        >
      </mat-select>
    </mat-form-field>
    <div class="flex flex-row flex-wrap gap-[8px]">
      <ng-container *ngFor="let smartHomeComponent of smartHomeComponents">
        <ng-container *ngIf="smartHomeComponent.selected">
          <div class="pill flex flex-row flex-wrap gap-[8px] justify-start items-center">
            <span>{{ smartHomeComponent.name }}</span
            ><mat-icon *ngIf="!smartHomeComponent.deleted" (click)="remove(smartHomeComponent)"
              >close</mat-icon
            >
          </div>
        </ng-container>
      </ng-container>
    </div>
    <button class="save-btn" data-at-save-btn mat-raised-button color="primary" (click)="save()">
      {{ '+INSTALLATIONS.INSTALLATION.SMART_HOME_COMPONENT.SAVE_COMPONENT' | translate }}
    </button>
  </app-feature-list-container>
</ng-container>
